import type { JSXElement } from "@fluentui/react-components";
import {
  Link,
  makeStyles,
  MessageBar,
  MessageBarBody,
  MessageBarIntent,
  MessageBarTitle,
} from "@fluentui/react-components";
import * as React from "react";

const useClasses = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

interface IntentProps {
  // Define any props if needed
    intent: MessageBarIntent;
    title: string;
    message: string;
    linkText?: string;
    linkUrl?: string;
}

const Intent: React.FC<IntentProps> = (props: IntentProps): JSXElement => {
  const classes = useClasses();

  return (
    <div className={classes.container}>
      {/* {intents.map((intent) => ( */}
        <MessageBar key={props.intent} intent={props.intent}>
          <MessageBarBody>
            <MessageBarTitle>{props.title}</MessageBarTitle>
            {props.message}{" "}
            {props.linkText && props.linkUrl && <Link href={props.linkUrl}>{props.linkText}</Link>}
          </MessageBarBody>
        </MessageBar>
      {/* ))} */}
    </div>
  );
};

export default Intent;